export default function PHP_hypot() {
  return (
    <div>
      <h1>PHP_hypot</h1>
    </div>
  );
}
